import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Button } from "react-bootstrap";

/**
 * Displays system announcements received at login, e.g. "Scheduled Maintenance"
 * User can permanently dismiss each message once viewed.
 */

class Announcement extends React.Component {
	constructor(props) {
		super(props);

		this.state = { messages: [] };

		this.announcementCheck = null;
		this.dismissed = [];
	}

	componentDidMount() {
		this.getUnread();
		// Check periodically to make sure message is still relevant
		this.announcementCheck = setInterval(
			() => this.getUnread(),
			5 * 60 * 1000, // 5 min
		);
	}

	componentDidUpdate({ previewMode: prevPreviewMode }) {
		const { previewMode } = this.props;
		if (prevPreviewMode !== previewMode) this.getUnread();
	}

	componentWillUnmount() {
		// Remove timer task
		clearInterval(this.announcementCheck);
	}

	/**
	 * Get dismissed message ids
	 */
	getDismissed = () => {
		this.dismissed = JSON.parse(localStorage.getItem("dismissed")) || [];
	};

	/**
	 * Build message list based on time and dismissal status
	 */
	getUnread = () => {
		this.getDismissed();
		let messages = [];
		const { data } = this.props;

		if (data?.length) {
			messages = data.filter(message => {
				const startTime = Date.parse(`${message.ActiveStartDateTime}+00:00`); // fix SQL date to UTC
				const endTime = Date.parse(`${message.ActiveEndDateTime}+00:00`);

				if (
					!this.dismissed[message.Id.toString()] &&
					Date.now() > startTime &&
					Date.now() < endTime
				) {
					return true;
				}

				return false;
			});
		}
		this.setState({ messages });
	};

	dismiss = id => {
		// convert id to string, otherwise implicit indexes will be created
		this.dismissed[id.toString()] = true;
		localStorage.setItem("dismissed", JSON.stringify(this.dismissed));
		this.getUnread(); // refresh list
	};

	parseMarkDown = (text = "") => {
		// Escape HTML characters
		const cleanText = text
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;");

		const html = cleanText
			.replace(/(\*\*|__)(?=\S)([^\r]*?\S[*_]*)\1/g, "<strong>$2</strong>")
			.replace(/(\*|_)(?=\S)([^\r]*?\S)\1/g, "<em>$2</em>")
			.replace(
				/\[([^\]]+)]\(([^(]+?)\)/g,
				'<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
			);

		// eslint-disable-next-line react/no-danger
		return <span dangerouslySetInnerHTML={{ __html: html }} />;
	};

	render() {
		const { lang } = global;
		const { messages } = this.state;
		const { previewMode } = this.props;

		return (
			<If condition={messages.length}>
				{messages.map(message => (
					<div
						key={message.Id}
						className={classNames({
							"announcement-message": true,
							warning: message.SeverityType === 20,
							error: message.SeverityType === 30,
						})}
					>
						<div className="animated fadeInUp">
							<span className="subject">{`${message.Subject}: `}</span>
							<span className="body">{this.parseMarkDown(message.Body)}</span>
							<If condition={!previewMode}>
								<Button
									bsStyle="link"
									onClick={() => this.dismiss(message.Id)}
								>
									{lang.t("Dismiss")}
								</Button>
							</If>
						</div>
					</div>
				))}
			</If>
		);
	}
}

Announcement.propTypes = {
	data: PropTypes.array,
	previewMode: PropTypes.bool,
};

Announcement.defaultProps = {
	data: [],
	previewMode: false,
};

export default Announcement;
